import { registerDynamicIslandVariant } from "../../dynamicIsland.registry";
import DynamicIslandItinerarySummaryContent from "./DynamicIslandItinerarySummaryContent";
import DynamicIslandItinerarySummaryMotionWrapper from "./DynamicIslandItinerarySummaryMotionWrapper";
import { getItinerarySummaryAnimationKey } from "./itinerarySummary.animation.tools";

/**
 * Registers the itinerary summary Dynamic Island variant.
 */
export function registerItinerarySummaryVariant(): void {
    registerDynamicIslandVariant( {
        "kind":             "itinerarySummary",
        "ContentComponent": DynamicIslandItinerarySummaryContent,
        "shell":            {
            "background":       true,
            "horizontalScroll": true,
        },
        "animation": {
            "getPayloadAnimationKey": getItinerarySummaryAnimationKey,
            "ContentMotionWrapper":   DynamicIslandItinerarySummaryMotionWrapper,
            "kindSwitchPriority":     2,
            "motionOverrides":        {
                "spring": {
                    "type":      "spring" as const,
                    "stiffness": 380,
                    "damping":   30,
                    "mass":      0.85,
                },
            },
        },
    } );
}
